<ng-container *ngIf="control.touched">
    <div class="invalid-feedback d-block" *ngIf="control.hasError('required')">
        This field is required
    </div>
    <div class="invalid-feedback d-block" *ngIf="control.hasError('pattern')">
        Invalid value provided
    </div>
    <div class="invalid-feedback d-block" *ngIf="control.hasError('email')">
        Invalid email
    </div>
    <div class="invalid-feedback d-block" *ngIf="control.hasError('MoreThanToday')">
        Date should be today or later
    </div>
    <div class="invalid-feedback d-block" *ngIf="control.hasError('LessThanDeadlineDate')">
        Delivery Date should be greater than Quotation Deadline Date
    </div>
    <div class="invalid-feedback d-block" *ngIf="control.hasError('7daysAheadCurrentday')">
        Date should be 7 days ahead from the current date
    </div>
    <div class="invalid-feedback d-block" *ngIf="control.hasError('consideredCost')">
        Value should be more threshold value
    </div>
    <div class="invalid-feedback d-block" *ngIf="control.hasError('ValidQuantity')">
        Enter Valid Quantity
    </div>
    <div class="invalid-feedback d-block" *ngIf="control.hasError('overCount')">
        Sum of confirmed Quantity is greater than actual quantity
    </div>
</ng-container>